/**
 * `useSearchViewStore` — the Search surface's ephemeral view state (frontend.md §2.2).
 *
 * This holds ONLY the per-surface UI state that is NOT in the URL. The search query, the
 * filters, the retrieval mode, and the grouping ARE in the URL (frontend.md §2.2, §2.3 —
 * a saved search is just a serialized URL). What is left for Zustand is the transient
 * stuff a refresh should not need to restore: which result the detail drawer is showing.
 */

import { create } from 'zustand';
import type { NoteId } from '@/types';

interface SearchViewState {
  /** The note open in `<ResultDetailDrawer>`; null when the drawer is closed. */
  detailDrawerNoteId: NoteId | null;
  openDetailDrawer: (noteId: NoteId) => void;
  closeDetailDrawer: () => void;
}

export const useSearchViewStore = create<SearchViewState>((set) => ({
  detailDrawerNoteId: null,
  openDetailDrawer: (detailDrawerNoteId) => set({ detailDrawerNoteId }),
  closeDetailDrawer: () => set({ detailDrawerNoteId: null }),
}));
